export {
  loadIntersectionObserverPolyfill as onClientEntry,
} from './intersection-observer-polyfill';

export const shouldUpdateScroll = ():Array<number> => [0, 0];
